import { CONTACT } from '@/mocks/contactInfo';

interface ButtonWhatsAppProps {
  children?: string;
}

export default function ButtonWhatsApp({ children = 'WhatsApp direct' }: ButtonWhatsAppProps) {
  return (
    <a
      href={CONTACT.whatsappHref}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center justify-center gap-2 whitespace-nowrap px-8 py-3.5 rounded-lg font-semibold text-base transition-all duration-200 bg-whatsapp-500 text-white hover:bg-whatsapp-600 cursor-pointer"
    >
      <i className="ri-whatsapp-line text-xl w-5 h-5 flex items-center justify-center"></i>
      {children}
    </a>
  );
}